import { Box, Button, Flex, useDisclosure, useToast } from "@chakra-ui/react";
import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  baseUrl,
  getConstraintsAPI,
  optimizeBurdenMixAPI,
} from "../../Redux/App/app.actions";
import TestChemistry from "./TestChemistry";
import { useNavigate } from "react-router-dom";
import LoadingModal from "../Modals/LoadingModal";
import ErrorModal from "../Modals/ErrorModal";
import errorIcon from "../Icons/error.png";
import axios from "axios";

const InputForm = () => {
  const [fileData, setFileData] = useState([]);
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  // console.log(state);
  const navigate = useNavigate();

  const [showResults, setShowResults] = useState(false);
  const [totalData, setTotalData] = useState([]);
  const [progressPercent, setProgressPercent] = useState(0);

  const toast = useToast();

  const handleOptimize = (e) => {
    e.preventDefault();
    if (showResults === true) {
      setShowResults(false);
      return;
    }
    if (state.app.inputFile == null) {
      toast({
        title: "No file uploaded",
        description: "please upload inventory file",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    // if (Object.keys(validationErrors).length > 0) {
    //   toast({
    //     title: "Validation error",
    //     description: "Please resolve any validation errors to conitnue",
    //     status: "error",
    //     duration: 3000,
    //     isClosable: true,
    //   });
    //   return;
    // }

    dispatch(optimizeBurdenMixAPI(state, fileData)).then((res) => {
      let { type, payload } = res;
      if (type === "RESPONSE_SUCCESS") {
        setShowResults((prev) => !prev);
        navigate("/output");
      }
    });
  };
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    dispatch(getConstraintsAPI()).then((res) => console.log({ res }));
  }, []);

  const response_loading = state.app.response_loading;

  useEffect(() => {
    console.log({ state });
  }, [state]);

  useEffect(() => {
    let intervalId;
    let progress_url = `${baseUrl}/b1/progress`;
    try {
      if (response_loading === true) {
        intervalId = setInterval(() => {
          axios.get(progress_url).then((res) => {
            let totalGenerations = state.app.bounds.controllers.filter(
              (el) =>
                el.category === "TOP_CONTROLLERS" && el.name === "generations"
            )[0].value;
            const percent = Math.floor(
              (Number(res.data) * 100) / Number(totalGenerations)
            );
            setProgressPercent(percent);
          });
        }, 3000);
      } else {
        setProgressPercent(0);
      }
    } catch (e) {
      console.log({ e });
    }

    return () => clearInterval(intervalId);
  }, [response_loading]);

  return (
    <Box w="100%" h="150vh" mt="1rem">
      <form onSubmit={handleOptimize}>
        <Flex w="98%" m="auto" direction="column">
          <LoadingModal
            isOpen={state.app.response_loading}
            onOpen={onOpen}
            onClose={onClose}
            title={"Loading"}
            text={"Please wait while we are optimizing the burden mix"}
            progressPercent={progressPercent}
          />
          <ErrorModal
            imageSrc={errorIcon}
            isOpen={state?.app?.response_failure}
            onOpen={onOpen}
            onClose={onClose}
            title={"Warning"}
            text={
              state?.app?.response_failure_message?.response?.data?.error ||
              "Network error"
            }
          />
          <TestChemistry
            totalData={totalData}
            setTotalData={setTotalData}
            showResults={showResults}
            // validationErrors={validationErrors}
            // setValidationErrors={setValidationErrors}
            fileData={fileData}
            setFileData={setFileData}
          />
          <Button
            colorScheme="green"
            m="auto"
            type="submit"
            mt="20px"
            _hover={{ backgroundColor: "green" }}
          >
            {showResults ? "TRY AGAIN" : "OPTIMIZE"}
          </Button>
        </Flex>
      </form>
    </Box>
  );
};

export default memo(InputForm);
